// Use the API deployment, not the browser hostname (localhost can use UAT).
const environments = {
  'production-portal-dev-api-uat.azurewebsites.net': 'uat',
  'production-portal-dev-api.azurewebsites.net': 'production',
};

export function deployedEnvironment(apiBase, endpoint, explicit = process.env.REACT_APP_SIGNALR_ENVIRONMENT) {
  try {
    const api = new URL(apiBase);
    const hub = new URL(endpoint);
    const path = value => value.pathname.replace(/\/+$/, '');
    // Never route notifications from a different API into the selected API's views.
    if (api.origin !== hub.origin || path(api) !== path(hub)) return undefined;
    const environment = explicit || environments[api.hostname];
    return ['dev', 'uat', 'production'].includes(environment) ? environment : undefined;
  } catch { return undefined; }
}
